(() => {
  const menus = {
    'new': [],
    'vegetables': [],
    'flowers': [],
    'herbs': [],
    'organic': [],
    'seed-form': [],
    'microgreens': [],
    'cover-crop': [],
    'sale': [],
  };

  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
  const px = value => value.toString() + 'px';

  const subHeader = document.querySelector('.header-sub');
  const subHeaderList = document.querySelector('.header-sub-list');

  const categoryLinks = [];

  var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(data => { document.getElementById('cartCountDisplay').innerHTML = data.item_count });

  const getID = raw => raw
    .split(' ').join('-')
    .split('&').join('and')
    .toLowerCase();

  const getSubLinkHTML = ({category, subcategory, url}) => /*html*/`
  <li class="nav-subparent-link flex" id="megamenu-${getID(category)}-${getID(subcategory)}">
    <a href="${url}" class="nav__item__link fw-bold text-uppercase nav__item--parent">${subcategory}</a>
    <div class="nav__item__dropdown  col-xs-12" id="dropdown-ec96532e-8d5b-459d-94a5-d33f85d5b303" style="right: 0px; left: auto;"></div>
  </li>
  `;

  const setVisible = (elem, isVisible) => elem && elem.classList[isVisible ? 'remove' : 'add']('d-none');
  const hide = elem => setVisible(elem, false);
  const show = elem => setVisible(elem, true);

  const headerState = {
    lastActive: {
      main: null,
      sub: null
    },
    mainCategoryDropdownOpen: false,
    hoveredElem: null
  };

  const getFirstNavItem = () => {
    const navList = document.querySelector('.main-nav__list');
    const found = [...navList.children].find(n => n.classList && n.classList.contains('nav-parent-link'));
    return found;
  };

  const positionDropdown = ({isSubCategory, dropdown, link}) => {
    if (!dropdown) return;
    const pos = link.getBoundingClientRect();
    const firstNav = getFirstNavItem();
    const firstNavPos = firstNav.getBoundingClientRect();

    const topOffset = isSubCategory ? -1 : 0;
    const leftOffset = -1;
    const scrollTop = window.pageYOffset;
    const topPos = pos.top + pos.height + scrollTop + topOffset;
    const leftPos = firstNavPos.left + leftOffset;

    dropdown.style.left = px(leftPos);
    dropdown.style.top = px(topPos);
  };

  const onHoverSubCategory = (event) => {
    hideAllDropdowns();
    const link = event.target;
    const dropdown = getDropdown(link.id);
    headerState.lastActive.sub = link;

    show(dropdown);
    positionDropdown({dropdown, link, isSubCategory: true});
  };

  const onUnhoverSubCategory = async event => {
    const { target: link } = event;
    const dropdown = getDropdown(link.id);
    console.log('Unhovering subcategory');
    await sleep(50);

    // Check if the mouse is not over the link or the dropdown
    if (!link.matches(':hover') && !dropdown.matches(':hover')) {
      link.classList.remove('active');
      hide(dropdown);
      console.log('Hidden subcategory');
    }
  };

  const populateSubHeader = (menuItem, subItems) => {
    console.log("subItems", subItems);
    subHeaderList.innerHTML = '';
    const subItemHTML = subItems.map(si => getSubLinkHTML({
      category: menuItem,
      subcategory: si[0],
      url: si[1]
    }));

    subHeaderList.innerHTML = subItemHTML.join('');

    const subLinks = [...document.querySelectorAll('.nav-subparent-link')];
    subLinks.forEach(sl => {
      sl.addEventListener('mouseenter', onHoverSubCategory);
      sl.addEventListener('mouseleave', onUnhoverSubCategory);
    });
  };

  const setActiveCategory = isActive => {
    const func = isActive ? 'add' : 'remove';
    const {sub, main} = headerState.lastActive;

    if (sub) sub.classList[func]('active');
    if (main) main.classList[func]('active');
  };

  const onHoverDropdown = event => {
    setActiveCategory(true);
  };

  const onUnhoverDropdown = async event => {
    const dropdown = event.target;
    await sleep(50);

    // Check if the mouse is not over the dropdown or the related link
    if (!dropdown.matches(':hover')) {
      hide(dropdown);
      headerState.lastActive.sub = null;
      headerState.lastActive.main = null;
    }
  };

  const getDropdown = id => {
    const dropdownClass = id.replace('megamenu-', 'dropdown-');
    const storage = document.querySelector('.megamenu-storage');
    const dropdown = storage.querySelector('.' + dropdownClass);
    return dropdown;
  };

  const hideAllDropdowns = () => {
    const storage = document.querySelector('.megamenu-storage');
    const dropdowns = [...storage.querySelectorAll('.nav-menu-dropdown')];
    dropdowns.forEach(hide);
  };

  const deactivateAllCategories = () => {
    const links = [...document.querySelectorAll('.nav-parent-link')];
    links.forEach(l => l.classList.remove('active'));
  };

  const onHoverCategory = (event, menuItem, subItems) => {
    const elem = event.target;

    hideAllDropdowns();
    headerState.lastActive.sub = null;

    categoryLinks.forEach(cl => {
      cl.classList[cl === elem ? 'add' : 'remove']('active');
    });

    if (subItems.length === 0) {
      hide(subHeader);

      const dropdown = getDropdown(elem.id);
      if (!dropdown) return;
      headerState.lastActive.main = elem;
      headerState.lastActive.sub = null;
      show(dropdown);
      positionDropdown({dropdown, link: elem, isSubCategory: false});
      headerState.mainCategoryDropdownOpen = true;

      return;
    }

    headerState.mainCategoryDropdownOpen = false;
    show(subHeader);
    populateSubHeader(menuItem, subItems);
  };

  const onUnhoverCategory = async event => {
    const { target: link } = event;
    const dropdown = getDropdown(link.id);
    await sleep(50);

    // Check if the mouse is not over the link or the dropdown
    if (!link.matches(':hover') && (!dropdown || !dropdown.matches(':hover'))) {
      link.classList.remove('active');
      hideAllDropdowns();
      deactivateAllCategories();
      hide(subHeader);
    }
  };

  const onHoverHomeButton = () => {
    deactivateAllCategories();
    hide(subHeader);
  };

  const onHoverNavDropdown = ({target: triggerElem}) => {
    const ddElem = triggerElem.nextElementSibling;
    
    const isValidDropdown = ddElem && ddElem.classList && ddElem.classList.contains('bt-dropdown__content');
    if (!isValidDropdown) return;

    const tp = triggerElem.getBoundingClientRect();
    const dp = ddElem.getBoundingClientRect();

    // Adjust the dropdown position if needed
  };

  const hideAll = () => {
    deactivateAllCategories();
    hideAllDropdowns();
    hide(subHeader);
  };

  const onHoverTopHeader = () => hideAll();

  const init = () => {
    const setOnHover = (nodeOrSelector, hoverFunc, unhoverFunc = null) => {
      const isNode = nodeOrSelector && typeof nodeOrSelector === 'object' && nodeOrSelector.classList;
      const elem = isNode ? nodeOrSelector : document.querySelector(nodeOrSelector);
      if (elem) {
        elem.addEventListener('mouseenter', hoverFunc);
        if (unhoverFunc) elem.addEventListener('mouseleave', unhoverFunc);
      } else {
        console.log("Element not found for selector:", nodeOrSelector);
      }
    };

    for (const [name, subcats] of Object.entries(menus)) {
      const categoryLink = document.querySelector(`#megamenu-${name}`);
      categoryLinks.push(categoryLink);

      const catOnHover = e => onHoverCategory(event, name, subcats);
      const catOnUnhover = e => onUnhoverCategory(event, name, subcats);
      setOnHover(categoryLink, catOnHover, catOnUnhover);
    }

    setOnHover('.home-button', onHoverHomeButton);
    setOnHover('.header-logos', onHoverTopHeader);

    const storage = document.querySelector('.megamenu-storage');
    const dropdowns = [...storage.querySelectorAll('.nav-menu-dropdown')];
    for (const dropdown of dropdowns) {
      setOnHover(dropdown, onHoverDropdown, onUnhoverDropdown);
    }

    document.onmousemove = event => {
      event = event || window.event;
      headerState.hoveredElem = event.target;
    };

    const triggers = [...document.querySelectorAll('.bt-dropdown__trigger')];
    triggers.forEach(t => t.addEventListener('mouseenter', onHoverNavDropdown));
  };
  init();
})();